import { httpsCallable } from 'firebase/functions';
import { functions } from '@/firebase';

const answerWithVeraCallable = httpsCallable(functions, 'veraAssistantV2');
const listKnowledgeCallable = httpsCallable(functions, 'veraAdminList');
const saveKnowledgeCallable = httpsCallable(functions, 'veraAdminSave');
const archiveKnowledgeCallable = httpsCallable(functions, 'veraAdminArchive');

function readableFunctionError(error, fallback) {
  const message = typeof error?.message === 'string'
    ? error.message.replace(/^FirebaseError:\s*/i, '').trim()
    : '';
  return message || fallback;
}

async function answerWithVera(payload) {
  try {
    const result = await answerWithVeraCallable(payload);
    return result.data;
  } catch (error) {
    throw new Error(readableFunctionError(error, 'Vera could not answer right now.'));
  }
}

async function listVeraKnowledge() {
  try {
    const result = await listKnowledgeCallable();
    return result.data.entries || [];
  } catch (error) {
    throw new Error(readableFunctionError(error, 'Vera knowledge could not be loaded.'));
  }
}

async function saveVeraKnowledge(entry) {
  try {
    const result = await saveKnowledgeCallable(entry);
    return result.data.entry;
  } catch (error) {
    throw new Error(readableFunctionError(error, 'Vera knowledge could not be saved.'));
  }
}

async function archiveVeraKnowledge(id) {
  try {
    await archiveKnowledgeCallable({ id });
  } catch (error) {
    throw new Error(readableFunctionError(error, 'Vera knowledge could not be archived.'));
  }
}

export {
  answerWithVera,
  archiveVeraKnowledge,
  listVeraKnowledge,
  saveVeraKnowledge,
};
